import { useState, useEffect } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { getPaymentPlans } from "../../../ApiService/ApiService";
import AddPlan from "./AddPlan";
import PlansTable from "./PlansTable";
import { Add } from "@mui/icons-material";

function PlansSection() {
  const [plans, setPlans] = useState({});
  const [showAddPlans, setShowAddPlans] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      setLoading(true);
      const response = await getPaymentPlans();
      setPlans(response?.data);
    } catch (err) {
      console.error("Error fetching plans:", err);
    } finally {
      setLoading(false);
    }
  };

  const renderMainContent = () => {
    if (showAddPlans) {
      return (
        <AddPlan fetchPlans={fetchPlans} setShowAddPlans={setShowAddPlans} />
      );
    } else {
      return <PlansTable plans={plans} fetchPlans={fetchPlans} />;
    }
  };

  return (
    <>
      <Box
        sx={{
          display: showAddPlans ? "none" : "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          paragraph
          sx={{
            fontWeight: 600,
            fontSize: 22,
            fontFamily: "Barlow, sans-serif",
          }}
          xs={4}
          sm={4}
          md={6}
          lg={8}
          xl={8}
        >
          Plans
        </Typography>
        <Button
          xs={8}
          sm={8}
          md={6}
          lg={4}
          xl={4}
          onClick={() => setShowAddPlans(true)}
          variant="contained"
          color="primary"
          size="small"
          sx={{
            marginBottom: 2,
            textTransform: "unset",
            borderRadius: 2,
          }}
        >
          <Add fontSize="small" />
          Add Plan
        </Button>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>{renderMainContent()}</>
      )}
    </>
  );
}

export default PlansSection;
